/**
 * Pipes an initial value through a sequence of functions.
 * Useful for linear data transformations without intermediate variables.
 *
 * @example
 *   pipe(slug, normalizeSlugForS3, buildUrls)
 *   pipe(name, s => s.toLowerCase(), s => s.replace(/\s+/g, '-'))
 */

export function pipe<A, B>(a: A, ab: (a: A) => B): B;
export function pipe<A, B, C>(a: A, ab: (a: A) => B, bc: (b: B) => C): C;
export function pipe<A, B, C, D>(a: A, ab: (a: A) => B, bc: (b: B) => C, cd: (c: C) => D): D;
export function pipe<A, B, C, D, E>(a: A, ab: (a: A) => B, bc: (b: B) => C, cd: (c: C) => D, de: (d: D) => E): E;
export function pipe(initialValue: unknown, ...fns: Array<(x: unknown) => unknown>): unknown {
  return fns.reduce((acc, fn) => fn(acc), initialValue);
}
